"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
function _templateObject() {
    var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  max-width: var(--container-small);\n\n  @media (max-width: ", ") {\n    flex-direction: column;\n  }\n\n  & > * {\n    margin-bottom: var(--gutter-small);\n    font-family: inherit;\n    font-size: inherit;\n  }\n\n  input, textarea {\n    display: block;\n    border: none;\n    border-bottom: 1px solid;\n    padding: .5rem;\n  }\n\n  .input--half {\n    @media (min-width: calc(", " + 1px)) {\n      width: 49%;\n    }\n  }\n  .input--full {\n    width: 100%;\n  }\n\n  textarea {\n    width: 100%;\n    min-height: 24rem;\n    border: 1px solid;\n  }\n"]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) {
    raw = strings.slice(0);
} strings.raw = raw; return strings; }
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const variables_1 = require("../../styles/variables");
var StyledContactForm = styled_1.default.form(_templateObject(), variables_1.breakpoints.medium, variables_1.breakpoints.medium);
var ContactForm = function ContactForm() {
    return /*#__PURE__*/ react_1.default.createElement(StyledContactForm, {
        name: "contact",
        method: "POST",
        "data-netlify": "true"
    }, /*#__PURE__*/ react_1.default.createElement("input", {
        "aria-label": "Enter you Name",
        className: "input--half",
        type: "text",
        name: "name",
        id: "name",
        placeholder: "Name"
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        "aria-label": "Enter you Email",
        className: "input--half",
        type: "email",
        name: "email",
        id: "email",
        placeholder: "Email"
    }), /*#__PURE__*/ react_1.default.createElement("input", {
        "aria-label": "Enter you Name",
        className: "input--full",
        type: "text",
        name: "subject",
        id: "subject",
        placeholder: "Subject"
    }), /*#__PURE__*/ react_1.default.createElement("textarea", {
        name: "message",
        id: "message",
        placeholder: "Your Message"
    }), /*#__PURE__*/ react_1.default.createElement("button", {
        className: "btn",
        type: "submit"
    }, "Send"));
};
exports.default = ContactForm;
